// extracted by mini-css-extract-plugin
export default {"user":"User_user__vm1W0"};